// extracted by css-extract-rspack-plugin
export default {"menuButton":"CopilotSplitButton-module__menuButton__qqKbX"};